module.exports = __webpack_public_path__ + "img/sweat-droplets.6538a02c.png";